import React, { useEffect, useRef, useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { postDuplicateTasks } from "../../store/actions";

const DuplicateTaskPopup = ({
  handleClose,
  show,
  ModalTitle,
  duplicateTaskName,
  duplicateTaskId,
}) => {
  const dispatch = useDispatch();
  const [taskName, setTaskName] = useState("Duplicate of " + duplicateTaskName);
  const [includeOptions, setIncludeOptions] = useState({
    owner: false,
    description: true,
    status: false,
    exp_start_date: false,
    exp_end_date: false,
    priority: false,
  });
  const inputRef = useRef(null);
  useEffect(() => {
    if (show && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
        inputRef.current.select();
      }, 0);
    }
  }, [show]);
  const handleCheckboxChange = (key) => {
    setIncludeOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleCreateNewTaskClicked = (taskName, includeOptions) => {
    let data = [
      {
        bi_id: localStorage.getItem("bi_id"),
        product_id: localStorage.getItem("product_id"),
        filters: includeOptions,
        new_task_name: taskName,
        task_id: duplicateTaskId,
      },
    ];
    dispatch(postDuplicateTasks(data));
  };
  return (
    <div>
      {show && (
        <div className="modal-overlay">
          <div
            className="modal-content"
            style={{
              height: "auto",
              width: "90%",
              maxWidth: "600px",
              margin: "50px auto",
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              className="modal-header"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div
                className="modal-title"
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                }}
              >
                {ModalTitle || "Duplicate Task"}
              </div>
              <button
                type="button"
                className="close"
                style={{ backgroundColor: "transparent", border: "none" }}
                onClick={handleClose}
              >
                <span style={{ fontSize: "35px", opacity: ".6" }}>&times;</span>
              </button>
            </div>
            <div style={{ color: "rgb(255, 63, 51)" }}>
              NOTE: Duplicating a Milestone or Parent Task will also duplicate
              all of its tasks and sub-tasks
            </div>
            <hr />
            <div className="modal-body">
              {/* Task Name Input */}
              <div style={{ marginBottom: "20px" }}>
                <label>Task Name</label>
                <input
                  className="form-control"
                  ref={inputRef}
                  type="text"
                  value={taskName}
                  onChange={(e) => setTaskName(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  required
                />
              </div>

              {/* Include Checkboxes */}
              <div>
                <label>Include</label>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {[
                    ["owner", "Owner"],
                    ["description", "Task description"],
                    ["status", "Status"],
                    ["exp_start_date", "Start date"],
                    ["exp_end_date", "Due date"],
                    ["priority", "Priority"],
                  ].map(([key, label]) => (
                    <div
                      key={key}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={includeOptions[key]}
                        onChange={() => handleCheckboxChange(key)}
                        id={key}
                      />
                      <label for={key} style={{ marginLeft: "8px" }}>
                        {label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className="modal-footer"
              style={{
                display: "flex",
                padding: "10px 0",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#0A5F59",
                  borderColor: "#0A5F59",
                }}
                onClick={() => {
                  handleCreateNewTaskClicked(taskName, includeOptions);
                  handleClose();
                }}
              >
                Create New Task
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DuplicateTaskPopup;
